import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Container, Stack, Typography } from '@mui/material';
// components
import { ProductList } from '../sections/@dashboard/products';
// mock
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import EmtyData from 'src/components/emty-data';
import Loader from 'src/components/loader/loader';
// import GroupDeviceModal from 'src/components/modal/GroupDevice';
import { sendRequest, serviceList } from 'src/utils';

// ----------------------------------------------------------------------
const ARR_ACION = {
    'borrow-local': { key: 'rorrowing_device', type: '0' },
    'take-local': { key: 'getting_device', type: '1' },
    'take-online': { key: 'lay_online', type: '1' },
    'borrow-online': { key: 'muon_online', type: '0' },
    'manager-devices': { key: 'nhap_xuat_tb', type: 'all' },
    tra_thiet_bi: { key: 'tra_thiet_bi', type: 'all' },
};
export default function GroupDeviceAction() {
    const [visible, setVisible] = useState(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const { t } = useTranslation();
    const params = useParams();
    const isEdit = useRef(false);
    const actionRef = useRef({ key: '', type: 'all' });
    const [data, setData] = useState({});
    const success = useRef(false);
    const getRef = useRef(false);
    const path = window.location.pathname;
    useEffect(() => {
        actionRef.current = ARR_ACION[path.split('/')[3]];
        console.log('actionRef.current', actionRef.current);

        setTimeout(() => {
            getData();
        }, 1000);
    }, [success.current]);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [+params.idPermission, actionRef.current?.type || 'all'];
        sendRequest(serviceList.getAllgroup_devicesUser, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [success.current]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <Helmet>
                <title> {t('group_devices')}</title>
            </Helmet>

            <Container>
                <Loader loading={getFlags} />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} flexWrap={'wrap'}>
                    <Typography variant="h4" gutterBottom>
                        {t('choose_group')} {t(actionRef.current?.key).toLowerCase()}
                    </Typography>{' '}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0} gap={1}>
                        {/* <Button
                            variant="contained"
                            component={RouterLink}
                            to={`/home/group-device/${params.idPermission}/property-default`}
                            startIcon={<Iconify icon="material-symbols:settings-motion-mode-outline-rounded" />}
                        >
                            {t('property')}
                        </Button> */}
                    </Stack>{' '}
                </Stack>
                <Breadcrumb paths={[{ label: t('choose_group'), url: '#', navigate: false }]} />
                {/* <GroupDeviceModal
                    isEdit={isEdit.current}
                    idPermission={params.idPermission}
                    visible={visible}
                    dataUpdate={data}
                    fuctGet={getData}
                    setVisible={setVisible}
                /> */}

                {tableData?.length > 0 ? (
                    <ProductList
                        products={tableData}
                        setData={setData}
                        isGroup
                        url={`/home/group/${path?.split('/')[3]}/${params.idPermission}/${path?.split('/')[3]}/`}
                        functEdit={() => {
                            isEdit.current = true;
                            // setData(item);
                            setVisible(true);
                        }}
                    />
                ) : (
                    <EmtyData />
                )}

                {/* <ProductCartWidget /> */}
                {/* {tableData[0]?.permiss_screen?.insert === '1' && (
                    <AddButton
                        onClick={() => {
                            isEdit.current = false;
                            setVisible(true);
                            setData({});
                        }}
                    />
                )} */}
            </Container>
        </>
    );
}
